import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { YardAdministrationComponent } from './component/yard-administration.component';
import { ApplicationClientCommonModule } from '@sdbn/appclient';
import { TmcYardCommonModule } from 'src/tmc-yard/common/common.module';
import { CommonTranslationModule } from '@sdbn/common';
import { TransportOptionsPanelModule } from 'src/tmc-yard/components/transport-options-panel/transport-options-panel.module';
import { TileButtonModule } from 'src/tmc-common/components/tile-button/tile-button.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    ApplicationClientCommonModule,
    TmcYardCommonModule,
    CommonTranslationModule,
    ServiceResponseModule,
    TransportOptionsPanelModule,
    TileButtonModule
  ],
  declarations: [
    YardAdministrationComponent
  ]
})
export class YardAdministrationModule { }
